import ReportsScreen from '../../components/reports/ReportsScreen';
import { useGenerateInvestorReportMutation } from '../../features/reports/reportsApi';

// GET /investor/reports — any authenticated investor, scoped
// automatically. type restricted to investments/transactions/
// support_tickets — no kyc, enforced by not offering it in the dropdown
// (see reportTypesForScope), not just by letting the 422 happen.
export default function Reports() {
  return <ReportsScreen scope="investor" useGenerateReportMutation={useGenerateInvestorReportMutation} />;
}
